export enum UpliftType {
  Percent = "Percent",
  Amount = "Amount",
}
export interface LibraryUplift {
  id: number;
  reason: string;
}

export interface Uplift {
  id: number;
  amount: number;
  type: UpliftType;
  baseUplift?: LibraryUplift | null;
  baseUpliftId?: number;
  order: number;
  autoFocus?: boolean | null;
  includeOnProposal?: boolean | null;
}

export interface UpliftInput {
  id: number;
  amount: number;
  type: UpliftType;
  baseUpliftId: number;
  includeOnProposal?: boolean | null;
}

export type LibraryUplifts = Record<string, LibraryUplift[]>;
